<template>
  <el-dialog
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    width="900px"
    top="20vh"
    class="noDetail"
  >
    <div class="main">
      <div v-if="type == 1 || type == 2" class="comment">
        <tinymce ref="editor" v-model="form.text" height="170" width="840"></tinymce>
      </div>
      <div v-if="type == 3" class="comment">
        <el-input
          v-model.trim="form.text"
          placeholder="请输入分数"
          clearable
          @keyup.native="form.text = inputNumber(form.text)"
        ></el-input>
      </div>
    </div>
    <div slot="footer" class="footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="sureFn">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Tinymce from '@/components/Tinymce'
import to from 'await-to'
import { changeQuestionName, changeQuestionAnwser, changeQuestionScore } from '@/api/exam'
export default {
  name: 'DialogResult',
  components: { Tinymce },
  data() {
    return {
      dialogVisible: false,
      form: {
        text: '',
      },
      type: 0,
      rowData: {},
      examRecordId: this.$route.query.id || '',
    }
  },
  methods: {
    show(type, data) {
      console.log('11111', type, data)
      this.type = type
      this.rowData = data
      this.dialogVisible = true
    },
    cancel() {
      this.form = {}
      this.dialogVisible = false
    },
    async sureFn() {
      if (this.type == 1) {
        const [, err] = await to(
          changeQuestionName({ id: this.rowData.questionId, questionName: this.form.text }),
        )
        if (err) return this.$message.error(err.msg)
        this.$message.success('修改题目成功')
      } else if (this.type == 2) {
        const [, err] = await to(
          changeQuestionAnwser({
            examRecordId: this.examRecordId,
            questionId: this.rowData.questionId,
            answer: this.form.text,
            optionId: this.rowData.optionList[0].optionId,
          }),
        )
        if (err) return this.$message.error(err.msg)
        this.$message.success('修改考试答案成功')
      } else if (this.type == 3) {
        const [, err] = await to(
          changeQuestionScore({
            examRecordId: this.examRecordId,
            questionId: this.rowData.questionId,
            score: Number(this.form.text),
          }),
        )
        if (err) return this.$message.error(err.msg)
      }
      this.form = {}
      this.dialogVisible = false
      this.$emit('success')
    },
    //效验输入框
    inputNumber(num) {
      let str = num.toString()
      str = str.replace(/[^\d.]/g, '')
      str = str.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      str = str.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      str = str
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      if (str < 0) {
        str = ''
        this.$message.warning('评分最小为0')
      } else if (str > 100) {
        str = ''
        this.$message.warning('评分最大为100')
      }
      return str
    },
  },
}
</script>
<style lang="scss" scoped>
.noDetail {
  ::v-deep .el-dialog__header {
    border-bottom: none;
    padding: 0px;
  }
  ::v-deep .el-dialog__body {
    padding: 0px;
    .main {
      // margin-top: 20px;
      padding: 30px 30px 20px 30px;
      .comment {
        margin-top: 20px;
        .tox-tinymce {
          width: 840px;
        }
      }
    }
  }
  /deep/.el-dialog__footer {
    padding: 10px;
    // text-align: center;
    border-top: none;
    .el-button {
      width: 120px;
    }
  }
}
</style>
